import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Input } from "reactstrap";
import deleteSubTeam from "../apis/deleteSubTeam";
import { useHistory } from "react-router-dom";

function RemoveSubTeamModal({
  remove_sub_team_modal,
  set_remove_sub_team_modal,
  set_edit_sub_team_modal,
  currentUser,
}) {
  console.log("remove_sub_team_modal: ", remove_sub_team_modal);
  return (
    <Modal
      className="invites-teammates-modal remove-subteam-modal"
      centered
      isOpen={!!remove_sub_team_modal}
      toggle={() => set_remove_sub_team_modal(null)}
    >
      <ModalHeader toggle={() => set_remove_sub_team_modal(null)}></ModalHeader>
      <ModalBody>
        <h3>Are you sure you want to delete this sub-team?</h3>
        <h3>{remove_sub_team_modal?.sub_name}</h3>
        <p className="mt-3 mb-5">
          Removing this team will reassign all teammates to Default
          (Unassigned). Note: This action is permanent and cannot be undone.
        </p>
        <div className="d-flex justify-content-between">
          <button
            className="back"
            onClick={() => set_remove_sub_team_modal(null)}
          >
            Back
          </button>
          <button
            className="remove"
            onClick={async () => {
              await deleteSubTeam({
                team_code: currentUser.team.id,
                sub_name: remove_sub_team_modal?.sub_name,
              });
              set_remove_sub_team_modal(null);
              set_edit_sub_team_modal(false);
            }}
          >
            Yes, Remove
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default RemoveSubTeamModal;
